import {
  convertDateStringToDateTimezone_7,
  formatDateToString,
  formatToCurrencyTypeToFixed,
} from "helper/common";
import React from "react";
import {FORMAT_TIME, LOAI_PHIEU_KHO} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";

const columns = (filterKhoNhap, filterKhoXuat): ColumnsEdit => {
  return [
    {
      title: "STT",
      dataIndex: "stt",
      render: (value, record, index) => index + 1,
      show: true,
      align: "center",
    },
    {
      title: "Số lô",
      key: "soLo",
      dataIndex: "soLo",
      show: true,
      align: "left",
    },
    {
      title: "Mã vật tư",
      key: "id",
      dataIndex: "id",
      show: true,
      align: "center",
    },
    {
      title: "Tên vật tư",
      key: "name",
      dataIndex: "name",
      show: true,
      align: "left",
    },
    {
      title: "Mã phiếu nhập/xuất",
      key: "phieuId",
      dataIndex: "phieuId",
      show: true,
      width: 100,
      align: "center",
    },
    {
      title: "Kho nhập",
      key: "khoNhap",
      dataIndex: "khoNhap",
      show: true,
      ...filterKhoNhap,
    },
    {
      title: "Kho xuất",
      key: "khoXuat",
      dataIndex: "khoXuat",
      show: true,
      ...filterKhoXuat,
    },
    {
      title: "Ngày hoàn thành phiếu",
      key: "ngayHoanThanh",
      dataIndex: "ngayHoanThanh",
      render(value, record, index) {
        return (
          <>
            {formatDateToString(
              convertDateStringToDateTimezone_7(value),
              FORMAT_TIME.dateTime
            )}
          </>
        );
      },
      show: true,
      align: "center",
    },
    {
      title: "Loại phiếu",
      key: "loaiPhieu",
      dataIndex: "loaiPhieu",
      render(value, record, index) {
        let text = "";
        if (value == LOAI_PHIEU_KHO.NHAP) {
          text = "Nhập";
        }
        if (value == LOAI_PHIEU_KHO.XUAT) {
          text = "Xuất";
        }
        if (value == LOAI_PHIEU_KHO.DU_TRU) {
          text = "Dự trù";
        }
        return <>{text}</>;
      },
      show: true,
      align: "center",
    },
    {
      title: "Số lượng",
      key: "soLuong",
      dataIndex: "soLuong",
      show: true,
      align: "right",
    },
    // {
    //   title: "Đơn giá nhập",
    //   key: "donGiaNhap",
    //   dataIndex: "donGiaNhap",
    //   show: true,
    //   align: "right",
    //   render(value, record, index) {
    //     return <>{formatToCurrencyTypeToFixed(value)}</>;
    //   },
    // },
    // {
    //   title: "Đơn giá bán",
    //   key: "donGiaBan",
    //   dataIndex: "donGiaBan",
    //   show: true,
    //   align: "right",
    //   render(value, record, index) {
    //     return <>{formatToCurrencyTypeToFixed(value)}</>;
    //   },
    // },
    // {
    //   title: "SL tồn",
    //   key: "soLuongTon",
    //   dataIndex: "soLuongTon",
    //   show: true,
    //   align: "right",
    // },
    // {
    //   title: "SL đã xuất",
    //   key: "SoLuongDaXuat",
    //   dataIndex: "SoLuongDaXuat",
    //   show: true,
    //   align: "right",
    // },
    // {
    //   title: "SL đã trả NCC",
    //   key: "SoLuongTraNCC",
    //   dataIndex: "SoLuongTraNCC",
    //   show: true,
    //   align: "right",
    // },
    // {
    //   title: "SL đã nhập",
    //   key: "SoLuongNhap",
    //   dataIndex: "SoLuongNhap",
    //   show: true,
    //   align: "right",
    // },
    {
      title: "Người lập phiếu",
      key: "nguoiLap",
      dataIndex: "nguoiLap",
      show: true,
      align: "left",
    },
    {
      title: "Ghi chú",
      key: "ghiChu",
      dataIndex: "ghiChu",
      show: true,
      align: "left",
    },
    // {
    //   title: "Thao tác",
    //   key: "action",
    //   dataIndex: "action",
    //   show: true,
    //   align: "center",
    //   fixed: "right",
    // },
  ];
};

export {columns};
